var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8515 0H4.7385C3.48177 0 2.27652 0.445744 1.38787 1.23917C0.499234 2.0326 0 3.10872 0 4.2308V18.3335C0 19.4556 0.499234 20.5317 1.38787 21.3251C2.27652 22.1185 3.48177 22.5643 4.7385 22.5643H26.8515C28.1082 22.5643 29.3135 22.1185 30.2021 21.3251C31.0908 20.5317 31.59 19.4556 31.59 18.3335V4.2308C31.59 3.10872 31.0908 2.0326 30.2021 1.23917C29.3135 0.445744 28.1082 0 26.8515 0ZM4.7385 2.82054H26.8515C27.2704 2.82054 27.6722 2.96912 27.9684 3.23359C28.2646 3.49807 28.431 3.85678 28.431 4.2308L15.795 11.1129L3.159 4.2308C3.159 3.85678 3.32541 3.49807 3.62162 3.23359C3.91784 2.96912 4.31959 2.82054 4.7385 2.82054ZM28.431 18.3335C28.431 18.7075 28.2646 19.0662 27.9684 19.3307C27.6722 19.5952 27.2704 19.7437 26.8515 19.7437H4.7385C4.31959 19.7437 3.91784 19.5952 3.62162 19.3307C3.32541 19.0662 3.159 18.7075 3.159 18.3335V7.44621L14.9737 13.8911C15.2138 14.0149 15.4861 14.0801 15.7634 14.0801C16.0407 14.0801 16.313 14.0149 16.5532 13.8911L28.431 7.44621V18.3335Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/email-white.45cf6d8cd0ddaa7d78a58eca1a92345c.svg";
export { ForwardRef as ReactComponent };